/**
 * Automy.Core.Enums.Reporting.Operations.ReportInternalTaskOperationType
 * JSON `operationType` (integer). Export = 1, RefreshDataset = 2.
 */
export default Object.freeze({
  Export: 1,
  RefreshDataset: 2,
});
